import React from "react";

const TurVirtual = () => {
  return (
    <section className="tur-virtual section-wrapper" id="tur">
      <header className="section-header">
        <h2>Tur virtual</h2>
      </header>
      <section className="section-container">
        <iframe
          title="tur virtual"
          loading="lazy"
          src="https://www.google.com/maps/embed?pb=!4v1566379359903!6m8!1m7!1sCAoSLEFGMVFpcE1ySlR6SDdfVlJMczN2ODhmTzdkS21uTUpObUhFVEsydV9SWF9p!2m2!1d45.52756157761505!2d25.37041603802868!3f0!4f0!5f0.4000000000000002"
          width="auto"
          height="auto"
          frameborder="0"
          allowfullscreen=""
        ></iframe>
      </section>
    </section>
  );
};

export default TurVirtual;
